export const equipment = {
    labels: {
    },
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {},
};
